import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { Stripe_customer } from '../../../models/accounting/banking/stripe_customer';
import { StripePaymentCardService } from '../../../providers/stripe-payment-card.service';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';
import { faSave, faPhoneSquare, faAt, faUser, faSpinner } from '@fortawesome/pro-regular-svg-icons';


@Component({
  standalone: false,
  selector: 'app-stripe-add-customer',
  templateUrl: './stripe-add-customer.component.html',
styleUrls:  ['./stripe-add-customer.component.css']
})
export class StripeAddCustomerComponent extends SmsAbstractAppPage implements OnInit {

    faSave = faSave;
    faPhoneSquare = faPhoneSquare;
    faAt = faAt;
    faUser = faUser;
	faSpinner = faSpinner;
    customer: Stripe_customer = new Stripe_customer({});
    @Output() customer_created$: EventEmitter<Stripe_customer> = new EventEmitter<Stripe_customer>();
    @Input() competition_organizer_id: string;
	customerSaving: boolean = false;

  constructor(private paymentCardService:StripePaymentCardService) {
    super();
  }

  ngOnInit(): void {
  }

  onSubmit(){

    this.customer.competition_organizer_id = this.competition_organizer_id;

  	if(this.customer.first_name == ''){
  		this.handleError("First name must have a value!");
  		return;
  	}
  	if(this.customer.last_name == ''){
  		this.handleError("Last name must have a value!");
  		return;
  	}
  	if(this.customer.email == ''){
  		this.handleError("Email must have a value!");
  		return;
  	}
  	if(this.customer.telephone == ''){
  		this.handleError("Telephone must have a value!");
  		return;
  	}

	this.customerSaving = true;
  	this.paymentCardService.createCustomer(this.customer).then(customer => {
  		this.customer_created$.emit(customer);
		this.customerSaving = false;
  	}).catch(error => {
  			this.handleError(error);
			this.customerSaving = false;
  		});

  }

}
